import React, { useState } from "react";
import cx from "classnames";
import { useMediaQuery } from "react-responsive";

import { Close, MapleLeaf } from "@components/Icon";
import { Text, Title } from "@components/Typography";
import Button from "@components/Button";

import styles from "./index.module.scss";

interface BannerProps {
  className?: string;
  onClose?: () => void;
}

const Banner: React.FC<BannerProps> = ({ className = "", onClose }) => {
  const [hideBanner, setHideBanner] = useState(false);
  const isDesktop = useMediaQuery({ query: "(min-width: 1024px)" });

  if (hideBanner) {
    return null;
  }

  const handleClose = () => {
    setHideBanner(true);

    // Call the onClose prop if provided
    if (onClose) {
      onClose();
    }

    // Dispatch a custom event for other components to listen for
    const event = new CustomEvent("bannerClosed");
    window.dispatchEvent(event);
  };

  return (
    <div id="Banner" className={cx(styles.Banner, className)}>
      <div className={styles.Container}>
        <div className={styles.CanadaIcon}>
          <MapleLeaf size={isDesktop ? 24 : 20} />
        </div>
        <div className={styles.Content}>
          <div>
            <Title variant="XS">SPECIAL OFFER - Get Mika free for a year!</Title>
            <Text>
              Applications are open for the Canada Health Infoway AI Scribe Program. Apply today!
            </Text>
          </div>
          <Button variant="outline" isSmall dark to="/infoway">
            Learn more
          </Button>
        </div>
        <div className={styles.CloseIcon} onClick={handleClose}>
          <Close />
        </div>
      </div>
    </div>
  );
};

export default Banner;
